// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__NS8ro","question":"Question_question__3b345","description":"Question_description__y8e45"};